import axiosInstance from "./axiosInstance";
import { LoginData, LoginResponse, RegistrationData } from "../types/Auth";
import { logApiError } from "./apiError";

export async function login(payload: LoginData): Promise<LoginResponse> {
    const response = await axiosInstance.post<LoginResponse>("/auth/login", payload);
    return response.data;
}

export async function register(payload: RegistrationData): Promise<void> {
    await axiosInstance.post("/auth/register", {
        organizationName: payload.organizationName,
        userName: payload.username,
        email: payload.email,
        password: payload.password,
    });
}

export async function requestRegistrationEmail(email: string): Promise<void> {
    await axiosInstance.post("/auth/encryption/email_check", {
        email,
        registrationUrl: `${window.location.origin}/register-complete`,
    });
}

export async function decodeRegistrationToken(token: string): Promise<{ email: string }> {
    const response = await axiosInstance
        .get<{ email: string }>("/auth/encryption/decrypt_email", { params: { email: token } })
        .catch(error => {
            logApiError(error);
            throw error;
        });
    if (!response.data?.email) {
        throw new Error("Invalid response: missing email");
    }
    return response.data;
}

/** OpenAPI `RandomPasswordAndHashDTO` — GET `/auth/password`. */
export type RandomPasswordAndHashDTO = {
    password: string;
    passwordHash: string;
};

export async function getRandomPasswordAndHash(): Promise<RandomPasswordAndHashDTO> {
    const response = await axiosInstance.get<RandomPasswordAndHashDTO>("/auth/password");
    return response.data;
}

export async function validatePasswordResetToken(token: string): Promise<{ email: string }> {
    const response = await axiosInstance.get<{ email: string }>("/auth/password-reset/validate", {
        params: { token },
    });
    return response.data;
}

export async function requestPasswordReset(email: string): Promise<void> {
    await axiosInstance.post("/auth/password-reset/request", {
        email,
        resetUrl: `${window.location.origin}/reset-password`,
    });
}

export async function confirmPasswordReset(token: string, newPassword: string): Promise<void> {
    await axiosInstance.post("/auth/password-reset/confirm", { token, newPassword });
}